/* unplugin-vue-components disabled */import { render } from "./templateDemeUploadEdit.vue?vue&type=template&id=bea28a50&scoped=true"
import script from "./templateDemeUploadEdit.vue?vue&type=script&lang=js"
export * from "./templateDemeUploadEdit.vue?vue&type=script&lang=js"

import "./templateDemeUploadEdit.vue?vue&type=style&index=0&id=bea28a50&scoped=true&lang=css"
import "./templateDemeUploadEdit.vue?vue&type=style&index=1&id=bea28a50&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bea28a50"]])

export default __exports__